import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { AppAuth } from '../../models/appAuth';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';
import { hasValue } from '../../shared/common-functions';
import { MenuService, SettingsService, TokenService } from '../../core';
import { MatDialog } from '@angular/material/dialog';
import { RoleId } from '../../models/role';
import { CookieService } from 'ngx-cookie-service';
const jwtHelper = new JwtHelperService();
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    loginApiUrl = environment.apiRoot + 'api/Login';
    private readonly currentUserSubject: BehaviorSubject<AppAuth>;
    public currentUser: Observable<AppAuth>;
    constructor(
        private readonly http: HttpClient,
        private readonly router: Router,
        private readonly settings: SettingsService,
        private readonly token: TokenService,
        private readonly menu: MenuService,
        private readonly dialogRef: MatDialog,
        private readonly cookieService: CookieService
    ) {
        this.currentUserSubject = new BehaviorSubject<AppAuth>(
            hasValue(sessionStorage.getItem('currentUserData')) ? this.getCurrentUserData(sessionStorage.getItem('currentUserData')) : jwtHelper.decodeToken(this.cryptoDecrypt(sessionStorage.getItem('currentUser')))
        );
        this.currentUser = this.currentUserSubject.asObservable();
    }
    public get currentUserValue(): AppAuth {
        return this.currentUserSubject.value;
    }
    public getCurrentUserData(data) {
        return JSON.parse(data);
    }
    login(formData) {
        let post_url = this.loginApiUrl;
        const headerOptions = new HttpHeaders();
        headerOptions.append('Content-Type', 'multipart/form-data');
        headerOptions.append('Accept', 'application/json');
        return this.http.post<any>(post_url, formData, { headers: headerOptions })
            .pipe(
                map(user_token => {
                    let userObj: any;
                    if (hasValue(user_token) && user_token !== '""') {
                        let userTokenEncrypted = this.cryptoEncrypt(user_token);
                        sessionStorage.setItem('token', userTokenEncrypted);
                        sessionStorage.setItem('currentUser', userTokenEncrypted);
                        userObj = jwtHelper.decodeToken(user_token);
                        this.currentUserSubject.next(userObj);
                    }
                    return userObj;
                })
            );
    }
    logout() {
        const formData = new FormData();
        this.http.post(environment.apiRoot + 'api/Login/SignOut', formData);
        console.log('authentication.service.ts');
        this.clearSessionCookie();
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('usr');
        sessionStorage.removeItem('jwt');
        localStorage.clear();
        sessionStorage.clear();
    }
    deleteCookie(name: string): void {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=localhost`;

    }

    clearSessionCookie(): void {
        document.cookie = '.AspNetCore.Session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }
    public getUserInfo() {
        let cus = this.currentUserSubject.value;
        return cus;
    }

    public getUserId() {
        let cus: any = this.currentUserSubject.value;
        let curRes = cus.LoginId.toLowerCase();
        return curRes;
    }
    public getUserName() {
        let cus: any = this.currentUserSubject.value;
        return cus.unique_name;
    }
    public isSuperAdmin() {
        let cus: any = this.currentUserSubject.value;
        return (parseInt(cus.RoleId) == RoleId.SuperAdmin);
    }
    public getUserRole() {
        let cus: any = this.currentUserSubject.value;
        return cus.UserRoleName;
    }
    public getUserEmail() {
        let cus: any = this.currentUserSubject.value;
        return cus.Email;
    }
    public getUserRoleId() {
        let cus: any = this.currentUserSubject.value;
        return cus.RoleId;
    }
    public getUsrId() {
        let cus: any = this.currentUserSubject.value;
        return cus.Id;
    }
 
    public cryptoEncrypt(data) {
        if (hasValue(data)) {
            let encrypted = CryptoJS.AES.encrypt(data, environment.application.secureKey);
            return encrypted.toString();
        }
    }
    public cryptoDecrypt(data) {
        if (hasValue(data)) {
            let decrypt = CryptoJS.AES.decrypt(data, environment.application.secureKey);
            return decrypt.toString(CryptoJS.enc.Utf8);
        }
    }
    public cryptoJSTestget(keys, value) {
        let key = CryptoJS.enc.Utf8.parse(keys);
        let iv = CryptoJS.enc.Utf8.parse(keys);
        let decrypted = CryptoJS.AES.decrypt(value, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    isLoggedIn(): boolean {
        return !!this.currentUserValue;
    }
}